import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import type {ConnectivityReducer} from 'setup'
import {RootState} from 'setup'

const ConnectivityBanner = () => {
  const intl = useIntl()
  const [showBanner, setShowBanner] = useState(false)
  const {isOnline, hasApiConnectivityIssue} = useSelector<RootState, ConnectivityReducer>(
    (state) => state.connectivityReducer,
    (a, b) => a.isOnline === b.isOnline && a.hasApiConnectivityIssue === b.hasApiConnectivityIssue
  )

  const hasIssue = !isOnline || hasApiConnectivityIssue

  // Debounce showing the banner: only show if the connectivity issue persists
  // for a few seconds. Brief blips (or unreliable state on load/refresh) clear
  // the timer before the banner ever appears. Hide immediately on recovery.
  useEffect(() => {
    if (!hasIssue) {
      setShowBanner(false)
      return
    }
    const t = setTimeout(() => setShowBanner(true), 5000)
    return () => clearTimeout(t)
  }, [hasIssue])

  if (!showBanner) return null

  const message = !isOnline
    ? intl.$t({id: 'CONNECTIVITY.NO_INTERNET'})
    : intl.$t({id: 'CONNECTIVITY.API_UNAVAILABLE'})

  return (
    <div
      className='connectivity-banner d-flex align-items-center justify-content-center px-4 py-2 text-white text-center fw-semibold'
      style={{
        position: 'sticky',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: '#dc3545',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        minHeight: '44px',
      }}
      role='alert'
    >
      <i className='fa fa-exclamation-triangle fs-5 me-2' aria-hidden />
      <span>{message}</span>
    </div>
  )
}

export default ConnectivityBanner
